export const getElementOptionsByType = (type) => {
  switch (type) {
    case 'single-line': {
      return {
        left: 2,
        width: 75,
        innerElemHeight: 5,
        height: 13,
      };
    }
    case 'text': {
      return {
        left: 2,
        width: 75,
        innerElemHeight: 19,
        height: 28,
        // Marks a text field drawn with the floating toolbar: its text sits at the
        // field's stored `top`, where fields authored before it sit lower by the room
        // the old button row and in-flow toolbar took (see utility/textFieldLayout).
        floatingToolbar: true,
      };
    }
    case 'multiline-line': {
      return {
        left: 2,
        width: 75,
        innerElemHeight: 13,
        height: 20,
      };
    }
    case 'number': {
      return {
        left: 2,
        width: 75,
        innerElemHeight: 5,
        height: 13,
      };
    }
    case 'email': {
      return {
        left: 2,
        width: 75,
        innerElemHeight: 5,
        height: 13,
      };
    }
    case 'phone': {
      return {
        left: 2,
        width: 75,
        innerElemHeight: 5,
        height: 13,
      };
    }
    case 'date': {
      return {
        left: 2,
        width: 75,
        innerElemHeight: 5,
        height: 13,
      };
    }
    case 'time': {
      return {
        left: 2,
        width: 75,
        innerElemHeight: 5,
        height: 13,
      };
    }
    case 'dropdown': {
      return {
        left: 2,
        width: 75,
        innerElemHeight: 4,
        height: 11,
      };
    }
    case 'single-line-header': {
      return {
        left: 2,
        width: 75,
        innerElemHeight: 5,
        height: 13,
      };
    }
    case 'signature': {
      return {
        left: 2,
        width: 75,
        innerElemHeight: 15,
        height: 24,
      };
    }
    case 'login': {
      return {
        left: 2,
        width: 75,
        innerElemHeight: 5,
        height: 13,
      };
    }
    case 'checkbox': {
      return {
        left: 2,
        innerElemHeight: 2,
        height: 10,
      };
    }
    case 'radiobutton': {
      return {
        left: 2,
        innerElemHeight: 2,
        height: 10,
      };
    }
    case 'rating': {
      return {
        left: 2,
        height: 9,
        innerElemHeight: 2,
      };
    }
    case 'name': {
      return {
        left: 2,
        height: 11,
        width: 96,
      };
    }
    case 'address': {
      return {
        left: 2,
        height: 20,
        width: 96,
      };
    }
    case 'link': {
      return {
        left: 2,
        height: 8,
      };
    }
    case 'file-attach': {
      return {
        left: 2,
        height: 12,
      };
    }
    case 'file-upload': {
      return {
        left: 2,
        height: 23,
        width: 75,
        innerElemHeight: 13,
      };
    }
    case 'submitters-field': {
      return {
        left: 2,
        height: 8,
      };
    }
    case 'table': {
      return {
        left: 2,
        height: 17,
        innerElemHeight: 5,
      };
    }
    case 'divider': {
      return {
        left: 2,
        height: 1,
        width: 96,
      };
    }
    case 'credits': {
      return {
        left: 2,
        width: 25,
        innerElemHeight: 5,
        height: 13,
      };
    }
  }
};
